<template>

    <div class="TQ_center">

        <!-- 1) image-->
        <tq-on-top-container v-if="p_displayRiddleImage_b">

            <div class="" slot="body">
                <tq-img-fill-blur :pp_img-url_s="p_qb_riddle_c.qbr_imgFile_blc_c[p_qb_displayLangCode_e] ? p_qb_riddle_c.qbr_imgFile_blc_c[p_qb_displayLangCode_e].fi_url_s : ass_img_image"
                                  :p_height_s="co_mainImageHeight_s"/>
            </div>

            <div slot="bottomRight" v-if="p_qb_metadata_c.qbm_missions_supportMissionsPoints_b" class="lc_pointsLabel TQ_borderBox TQ_text_20px TQ_bold TQ_bg_purple_lite TQ_padding_4px TQ_direction_rtl">
                <div class="TQ_inline">
                    <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                </div>
                <div class="TQ_padding_2px TQ_inline TQ_verticalAlignMiddle"></div>
                <div class="TQ_verticalAlignMiddle TQ_inline"> {{p_qb_riddle_c.cm_gbr_totalPoints_n()}} </div>
            </div>
        </tq-on-top-container>

        <!-- 2) title -->
        <div class="TQ_center lc_title TQ_fullScreen"
             :class="{'TQ_borderRadius_top' : p_cardsMode_b}"
             :style="co_dom_titleStyle_s">
            {{p_qb_riddle_c.qbr_title_blc_s[p_qb_displayLangCode_e]}}
        </div>

        <!-- 3) riddle body  -->
        <div class="TQ_padding_16px">
            <div   @click="m_clickHtmlBody_f"
                   v-html="m_formatHtml_f(p_qb_riddle_c.qbr_body_blc_c[p_qb_displayLangCode_e].w_body_s)" ></div>
        </div>

        <!-- 4) map section -->
        <div v-if="p_qb_riddle_c.qbr_metadata_c.qbrm_mapSection_b">

            <tq-google-map
                    v-if="p_qb_metadata_c.qbm_mapMissions_mapType2_e === enum_mapTypes.googleMap"
                    class="TQ_height_bodyFullScreen TQ_margin_4px TQ_borderRadius"

                    :p_display_lang-code_e="p_qb_displayLangCode_e"

                    :pb_center-map_c="p_qb_riddle_c.qbr_mapData_c.md_center_c"
                    :pb_zoom_n="p_qb_riddle_c.qbr_mapData_c.md_zoom_n"
                    :p_polygons_ac="p_qb_riddle_c.qbr_mapData_c.md_polygons_ac"

            />

            <tq-leaflet-display
                    v-else

                    :key="p_name_s + refreshMapCounter_n"
                    class="TQ_height_300px TQ_borderRadius"

                    :pb_map-uid_s="p_name_s"
                    :p_display_lang-code_e="p_qb_displayLangCode_e"


                    :p_map-data_c="p_qb_riddle_c.qbr_mapData_c"
                    :p_polygons_ac="p_qb_riddle_c.qbr_mapData_c.md_polygons_ac"

                    :p_players-location_by-user-id_c="p_playersLocation_byUserId_c"

                    :p_current-user-location_c="p_currentUserLocation_c"
                    :pf_two-fingers-movement_b="true"

                    :pe_start-watch-position_f="pe_startWatchPosition_f"
                    :pe_stop-watch-position_f="pe_stopWatchPosition_f"
            />


        </div>

        <!-- 5) riddle clock -->
        <div>
            <!-- ready clock -->
            <div v-if="co_missionClock_ready_b" class="TQ_border_top">
                <tq-btn-approve
                        class="TQ_inline TQ_margin_8px"
                        :system-lang-code="p_qb_displayLangCode_e"
                        :popup-text="ass_strings.sentence_showMission"
                        :approve-cb="m_userEvents_startMissionClock_f">
                    <tq-beacon :p_show-beacon_b="true" class="TQ_clickable TQ_inline">
                        <div class="TQ_padding_8px TQ_bg_purple TQ_margin_16px TQ_inline TQ_clickable TQ_box_shadow TQ_borderRadius TQ_text_24px ">
                            {{ass_strings.twoWords_showMission[p_system_langCode_e]}}
                        </div>
                    </tq-beacon>
                </tq-btn-approve>
            </div>

            <!-- running clock-->
            <div v-if="co_missionClock_running_b" :style="co_dom_subTitleStyle_s" class="TQ_padding_8px TQ_text_24px TQ_margin_8px_0">
                {{clockFormatTime_s}}
            </div>

            <!-- finish clock -->
            <div v-if="co_missionClock_finish_b" :style="co_dom_subTitleStyle_s" class="TQ_padding_8px TQ_text_24px TQ_margin_8px_0">
                {{co_totalFinishMissionTime_s}}
            </div>
        </div>

        <!-- 6) clues and locks-->
        <div v-if="!co_supportMissionClock_b || !co_missionClock_ready_b">

            <!-- 6.1) riddle clues -->
            <div v-if="p_qb_metadata_c.qbm_missions_cluesMode_e !== enum_cluesMode_e.none">

                <!-- used clues-->
                <div v-for="(qbr_clue_c, clueIndex) in p_qb_riddle_c.qbr_clues_ac"
                     v-if="m_showClue_fb(clueIndex)">
                    <div class="TQ_center TQ_text_16px riddleSubTitle" :style="co_dom_subTitleStyle_s">
                        {{qbr_clue_c.qbrc_title_blc_s[p_qb_displayLangCode_e]}}
                    </div>
                    <div class="TQ_padding_8px">
                        <div @click="m_clickHtmlBody_f" v-html="m_formatHtml_f(qbr_clue_c.qbrc_body_blc_c[p_qb_displayLangCode_e].enc_value_s)" ></div>

                        <div v-if=" [enum_cluesMode_e.points, enum_cluesMode_e.points_gradual].includes(p_qb_metadata_c.qbm_missions_cluesMode_e)"
                             class="TQ_text_bold TQ_padding_4px TQ_bg_red TQ_inline TQ_borderRadius TQ_margin_bottom_2px TQ_margin_top_4px TQ_direction_ltr">
                            <div class="TQ_text_bold TQ_inline TQ_verticalAlignTop"> -{{qbr_clue_c.qbrc_pointsWorth_n}}</div>
                            <div class="TQ_padding_2px TQ_inline TQ_verticalAlignTop"></div>
                            <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_16px TQ_inline TQ_verticalAlignTop"/>

                        </div>
                    </div>

                </div>

                <!-- divider -->
                <div class="TQ_padding_4px" :style="co_dom_subTitleStyle_s" v-if="co_dom_showGetClue_b"></div>

                <!-- clue button -->
                <tq-loader-button :show-loader="loaderClueBtn_b"
                                  v-if="co_dom_showGetClue_b && !co_finishCurrentRiddle_b"
                                  class=" TQ_borderRadius TQ_margin_16px">
                    <div class="TQ_btn TQ_bg_gold_w TQ_borderRadius"
                         @click="m_userEvents_clickGetClue_f()">

                        <img class="TQ_width_24px TQ_verticalAlignMiddle" :src="ass_img_idea_w" />
                        <div class="TQ_padding_4px TQ_inline"> </div><!-- space-->
                        <div class="TQ_text_16px TQ_inline TQ_verticalAlignMiddle">{{ass_strings.twoWords_revealHint[p_system_langCode_e]}}</div>
                    </div>
                </tq-loader-button>

            </div>

            <!-- 6.2) riddle locks -->
            <div v-for="(lock_c,lockIndex_n) in co_qbr_locks_ac">

                <!-- lock title-->
                <div class="TQ_center TQ_text_16px riddleSubTitle"
                     :style="co_dom_subTitleStyle_s">
                    {{lock_c.qbrl_title_blc_s[p_qb_displayLangCode_e]}}
                </div>

                <!-- lock body -->
                <div v-if="!lock_c.qbrl_body_blc_c[p_qb_displayLangCode_e].cm_w_emptyBody_fb()"
                     @click="m_clickHtmlBody_f"
                     v-html="m_formatHtml_f(lock_c.qbrl_body_blc_c[p_qb_displayLangCode_e].w_body_s)" class="TQ_border_bottom TQ_padding_16px TQ_margin_bottom_8px"></div>

                <!-- skiped lock-->
                <div v-if="m_dom_skipLock_fb(lockIndex_n)" class="TQ_inline TQ_bg_red TQ_padding_8px TQ_borderRadius TQ_margin_8px">
                    <tq-image :pb_src_r="ass_img_skip_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                    <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px"></div>
                    <div class="TQ_text_bold TQ_inline TQ_verticalAlignMiddle"> {{ass_strings.twoWords_SkippedRiddle[p_qb_displayLangCode_e]}}</div>
                </div>

                <!-- locks -->
                <div v-else>

                    <!-- TRIVIA-->
                    <tq-trivia v-if="lock_c.qbrl_type_e === enum_lockTypes.TRIVIA"
                               :p_rd_lock_c="lock_c"
                               :p_rs_unlock-data_c="p_riddleStatus_c ? p_riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n] : null"
                               :p_user-id_uid="p_userId_uid"
                               :p_qb_display-lang-code_e="p_qb_displayLangCode_e"

                               :pe_start-trivia_f="(cb_f) => {m_userEvents_startTrivia_f(lockIndex_n, cb_f)}"
                               :pe_finish-trivia_f="(ans_aas, startTrivia_t, cb_f) => {m_userEvents_finishTrivia_f(lockIndex_n, startTrivia_t, ans_aas, cb_f)}"/>

                    <!-- QUIZ -->
                    <div v-else-if="[enum_lockTypes.QUIZ, enum_lockTypes.WORDS, enum_lockTypes.INCLUDE_WORD,enum_lockTypes.OPTIONS].includes(lock_c.qbrl_type_e)" class="TQ_maxWidth_300px TQ_center">
                        <!-- Questions -->
                        <div v-for="(qbrl_questions_c, questionIndex_n) in lock_c.qbrl_questions_ac" class="TQ_margin_8px ">

                            <!-- 1 question body -->
                            <div v-html="m_formatHtml_f(qbrl_questions_c.qbrlq_body_blc_c[p_qb_displayLangCode_e].w_body_s)" class="TQ_margin_bottom_8px"></div>

                            <!-- words -->
                            <div v-if="qbrl_questions_c.qbrlq_type_e === enum_lockQuestionsTypes.WORDS" >
                                <div v-for="ansIndex in qbrl_questions_c.qbrlq_ansNum_blc_n[p_qb_displayLangCode_e]" class="TQ_margin_8px">

                                    <div v-if="m_dom_finishLock_fb(lockIndex_n)">
                                        <input disabled
                                               class="TQ_input"
                                               :value="m_getRiddleStatus_unlock_fc(lockIndex_n).rsud_quizUserAns_byQuestionIndex_as[questionIndex_n][ansIndex-1]"/>
                                    </div>

                                    <input-fast-delete
                                            v-else
                                            class="TQ_margin_4px"
                                            delete-img-class="TQ_img TQ_img_19px"
                                            :input-placeholder="ass_strings.oneWord_answer[p_system_langCode_e]"
                                            input-class="TQ_input_fullScreen TQ_center TQ_text_16px"
                                            :update-text="(text) => {m_localUserAns_set_f(lockIndex_n, questionIndex_n, ansIndex-1,text)}"/>

                                </div>
                            </div>

                            <!-- Options -->
                            <div v-else-if="qbrl_questions_c.qbrlq_type_e === enum_lockQuestionsTypes.OPTIONS" >

                                <div v-for="ansIndex in qbrl_questions_c.qbrlq_ansNum_blc_n[p_qb_displayLangCode_e]" >

                                    <!-- unlock -->
                                    <div v-if="m_dom_finishLock_fb(lockIndex_n)" class="TQ_margin_8px">
                                        <input disabled
                                               class="TQ_input"
                                               :value="m_getRiddleStatus_unlock_fc(lockIndex_n).rsud_quizUserAns_byQuestionIndex_as[questionIndex_n][ansIndex-1]"/>
                                    </div>

                                    <!-- lock question-->
                                    <tq-dropdown v-else class="TQ_input_fullScreen" :style-select="true">

                                        <div slot="select" class="select">
                                            {{m_localUserAns_get_f(lockIndex_n, questionIndex_n, ansIndex-1)}}
                                        </div>

                                        <div    slot="options"
                                                @click="m_localUserAns_set_f(lockIndex_n, questionIndex_n, ansIndex-1, option_c.enc_value_s)"
                                                class="option"
                                                :class="{'TQ_optionSelected': m_localUserAns_get_f(lockIndex_n, questionIndex_n, ansIndex-1) === option_c}"
                                                v-for="(option_c, index_n) in qbrl_questions_c.qbrlq_ansOptions_blc_ac[p_qb_displayLangCode_e]"
                                                :key="index_n">
                                            {{option_c.enc_value_s}}
                                        </div>
                                    </tq-dropdown>
                                </div>
                            </div>

                            <!-- include word -->
                            <div v-else-if="qbrl_questions_c.qbrlq_type_e === enum_lockQuestionsTypes.INCLUDE_WORD" >

                                <div v-if="m_dom_finishLock_fb(lockIndex_n)" class="TQ_margin_8px">
                                    <input disabled
                                           class="TQ_input"
                                           :value="m_getRiddleStatus_unlock_fc(lockIndex_n).rsud_quizUserAns_byQuestionIndex_as[questionIndex_n][0]"/>
                                </div>

                                <input-fast-delete
                                        v-else
                                        delete-img-class="TQ_img TQ_img_19px"
                                        :input-placeholder="ass_strings.oneWord_answer[p_system_langCode_e]"
                                        input-class="TQ_input_fullScreen TQ_center TQ_text_16px"
                                        :update-text="(text) => {m_localUserAns_set_f(lockIndex_n, questionIndex_n, 0, text)}"/>

                            </div>

                        </div>

                    </div>

                    <!-- image/video lock -->
                    <div v-else-if="[enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(lock_c.qbrl_type_e)" class="TQ_margin_8px">

                        <!-- upload image/video -->
                        <div>

                            <!-- uploaded image  -->
                            <div v-if="m_dom_getLockDisplayImgFile_c(lockIndex_n, 0) != null">

                                <div class="TQ_btn TQ_bg_gray1 TQ_textColor_white TQ_margin_bottom_8px"
                                     v-if="lock_c.qbrl_autoApprove_b || m_getRiddleStatus_unlock_fc(lockIndex_n).rsud_lockState_e !== enum_lockStatus.approved"
                                     @click="m_userEvents_clickLockFile_f(lockIndex_n)">
                            <span v-if="lock_c.qbrl_type_e === enum_lockTypes.VIDEO">
                                {{ass_strings.twoWords_changeVideo[p_system_langCode_e]}}
                            </span>
                                    <span v-else>
                                {{ass_strings.twoWords_changeImage[p_system_langCode_e]}}
                            </span>

                                </div>
                                <br>
                                <display-file max-width="300px" :file="m_dom_getLockDisplayImgFile_c(lockIndex_n, 0)"/>
                            </div>

                            <!-- no image/video square-->
                            <div v-else-if="m_getRiddleStatus_unlock_fc(lockIndex_n).rsud_lockState_e !== enum_lockStatus.approved"
                                 class="TQ_inline TQ_maxWidth_200px TQ_border TQ_padding_32px TQ_bg_gray4 TQ_text_20px TQ_margin_bottom_8px TQ_clickable"
                                 @click="m_userEvents_clickLockFile_f(lockIndex_n)">
                                <span v-if="[enum_lockTypes.IMAGE].includes(lock_c.qbrl_type_e)">{{ass_strings.fourWords_clickToUploadPhoto[p_system_langCode_e]}}</span>
                                <span v-else>
                                    {{ass_strings.fourWords_clickToUploadVideo[p_system_langCode_e]}}<br>
                                    <span class="TQ_text_14px">({{ass_strings.sentence_videoLengthMax[p_system_langCode_e].replace("$1", lock_c.qbrl_videoMaxTime_n)}})</span><br>
                                </span>
                            </div>
                        </div>

                        <!-- approve label-->
                        <div class="TQ_maxWidth_300px TQ_center" v-if="[enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(lock_c.qbrl_type_e)">
                            <div v-if="m_getRiddleStatus_unlock_fc(lockIndex_n).rsud_lockState_e === enum_lockStatus.approved"
                                 class="TQ_padding_8px TQ_text_bold TQ_text_20px TQ_bg_green">
                                {{ass_strings.oneWord_approved[p_system_langCode_e]}}
                            </div>
                            <div v-else-if="m_getRiddleStatus_unlock_fc(lockIndex_n).rsud_lockState_e === enum_lockStatus.notApproved"
                                 class="TQ_padding_8px TQ_text_bold TQ_text_20px TQ_bg_red">
                                {{ass_strings.twoWords_notApproved[p_system_langCode_e]}}

                            </div>
                            <div v-else-if="m_dom_getLockDisplayImgFile_c(lockIndex_n, 0) != null"
                                 class="TQ_padding_8px TQ_text_bold TQ_text_20px TQ_bg_gold_w">
                                {{ass_strings.threeWords_waitingToApprove[p_system_langCode_e]}}
                            </div>
                        </div>


                    </div>

                    <!-- GPS LOCK -->
                    <div v-else-if="[enum_lockTypes.GPS].includes(lock_c.qbrl_type_e)" class="TQ_margin_8px">

                        <!-- loader-->
                        <div v-if="loaderSubmitBtnIndex_n === lockIndex_n" class="TQ_padding_8px">

                            <!-- please rotate phone -->
                            <div v-if="showGpsNotAccurateMsg_b" class="TQ_text_bold">
                                <div class="TQ_text_20px TQ_margin_bottom_4px">
                                    {{ass_strings.sentence_weekGpsSignal[p_system_langCode_e]}}
                                </div>
                                <div class="TQ_margin_bottom_4px">
                                    1. {{ass_strings.sentence_checkGpsSettings[p_system_langCode_e]}}
                                </div>
                                <tq-image :pb_src_r="ass_gif_gpsCalibrate" class="TQ_width_150px TQ_borderRadius"/>
                                <div class="TQ_text_bold">
                                    2. {{ass_strings.sentence_rotateYourPhone[p_system_langCode_e]}}
                                </div>
                            </div>

                            <!-- searching location -->
                            <div v-else>
                                <tq-image :pb_src_r="ass_gif_gpsSearchingLocation" class="TQ_width_150px TQ_borderRadius"/>
                                <div class="TQ_text_bold">
                                    {{ass_strings.threeWords_checkingYourLocation[p_system_langCode_e]}}...
                                </div>
                            </div>

                        </div>

                        <!-- btn check location -->
                        <div v-else-if="!p_riddleStatus_c || !p_riddleStatus_c.rs_m_finishActionLock_b(lockIndex_n)">

                            <tq-btn-approve
                                class="TQ_margin_8px TQ_inline"
                                :approve-cb="() => m_lockGps_checkMyCurrentLocation_f(lock_c, lockIndex_n)"
                                :popup-text="ass_strings.question_checkCurrentLoction"
                                :system-lang-code="p_qb_displayLangCode_e">
                                <div  class="TQ_padding_8px TQ_clickable TQ_bg_green TQ_inline TQ_box_shadow TQ_borderRadius">
                                    <tq-image :pb_src_r="ass_img_gps_w" class="TQ_width_24px TQ_inline TQ_verticalAlignMiddle"/>
                                    <div class="TQ_inline TQ_padding_4px"></div>
                                    <div class="TQ_inline TQ_verticalAlignMiddle">
                                        {{ass_strings.threeWords_checkMyLocation[p_system_langCode_e]}}
                                    </div>
                                    <span>
                                            ({{m_lockGps_numOfTries_n(lockIndex_n)}})
                                        </span>
                                </div>
                            </tq-btn-approve>

                        </div>

                        <!-- finish lock-->
                        <div v-else class="TQ_padding_8px TQ_text_bold">

                            <!-- num of mistakes-->
                            <div class="TQ_margin_bottom_4px">
                                {{ ass_strings.sentence_foundLocation[p_system_langCode_e] }}
                                ({{ m_lockGps_numOfTries_n(lockIndex_n) }}
                                {{ ass_strings.oneWord_tries[p_system_langCode_e] }})
                            </div>

                            <!-- points lock -->
                            <div class="TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius TQ_direction_ltr " >
                                <div class="TQ_text_bold TQ_inline TQ_verticalAlignTop"> +{{p_riddleStatus_c.rs_m_actionLock_calcPoints_n(lockIndex_n)}}</div>
                                <div class="TQ_padding_2px TQ_inline TQ_verticalAlignTop"></div>
                                <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_16px TQ_inline TQ_verticalAlignTop"/>
                            </div>

                        </div>

                         <!-- answers table -->
                        <table v-if="p_riddleStatus_c && p_riddleStatus_c.rs_lockActions_byLockIndex_byTime_c[lockIndex_n]" class="TQ_inline TQ_text_14px">

                            <!-- header -->
                            <tr>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_date[p_qb_displayLangCode_e]}}
                                </td>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_player[p_qb_displayLangCode_e]}}
                                </td>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_distance[p_qb_displayLangCode_e]}}
                                </td>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_status[p_qb_displayLangCode_e]}}
                                </td>

                            </tr>

                            <!-- body-->
                            <tr v-for="rs_action_c in p_riddleStatus_c.rs_lockActions_byLockIndex_byTime_c[lockIndex_n]" :key="rs_action_c.rsla_timestamp_t">

                                <!-- date -->
                                <td v-if="m_getOtherUserData_c(rs_action_c.rsla_userId_uid)" class="TQ_padding_4px TQ_border_bottom">
                                    {{format_date_YYYY_MM_DD_hh_mm_fs(rs_action_c.rsla_timestamp_t)}}
                                </td>

                                <!-- user name -->
                                <td v-if="m_getOtherUserData_c(rs_action_c.rsla_userId_uid)" class="TQ_padding_4px TQ_border_bottom">
                                    {{m_getOtherUserData_c(rs_action_c.rsla_userId_uid).ud_name_s}}
                                </td>

                                <!-- distance -->
                                <td class="TQ_padding_4px TQ_border_bottom">
                                    {{m_calculateDistance_n(lock_c, rs_action_c)}}m
                                </td>

                                <!-- points -->
                                <td class="TQ_padding_4px TQ_border_bottom" >
                                    <tq-image :pb_src_r="rs_action_c.rsla_rightAns_b ? ass_img_checked : ass_img_closeRed" class="TQ_width_20px"/>
                                </td>

                            </tr>

                        </table>

                    </div>

                    <!-- btns  -->
                    <div v-if="!m_dom_finishLock_fb(lockIndex_n)" class="TQ_maxWidth_300px TQ_center" :class="loaderSkipBtn_b ? 'TQ_grid_col_Auto1frAuto' : ''">

                        <!-- submit btn -->
                        <tq-loader-button :show-loader="loaderSubmitBtnIndex_n === lockIndex_n"
                                          v-if="[enum_lockTypes.QUIZ, enum_lockTypes.WORDS, enum_lockTypes.INCLUDE_WORD, enum_lockTypes.OPTIONS].includes(lock_c.qbrl_type_e)">
                            <div class="TQ_btn TQ_bg_green TQ_borderRadius TQ_margin_4px TQ_margin_bottom_16px"
                                 @click="m_userEvents_submitQuizAns_f(lockIndex_n)">
                                <img class="TQ_width_24px TQ_verticalAlignMiddle" :src="ass_img_lock_white" />
                                <div class="TQ_padding_4px TQ_inline"></div>
                                <div class="TQ_inline TQ_verticalAlignMiddle">
                                    {{ass_strings.oneWord_submit[p_qb_displayLangCode_e]}}
                                </div>
                            </div>

                        </tq-loader-button>

                        <!-- space -->
                        <div class="TQ_padding_16px TQ_inline" v-if="lock_c.qbrl_skippable_b && p_skipsLeft_n>0 && [enum_lockTypes.QUIZ, enum_lockTypes.WORDS, enum_lockTypes.INCLUDE_WORD, enum_lockTypes.OPTIONS].includes(lock_c.qbrl_type_e)"></div>

                        <!-- skip button -->
                        <tq-loader-button :show-loader="loaderSkipBtn_b"
                                          v-if="lock_c.qbrl_skippable_b && p_skipsLeft_n>0">

                            <tq-btn-approve
                                    class="TQ_bg_red TQ_btn TQ_borderRadius TQ_margin_4px"
                                    img-class="TQ_width_24px"
                                    :system-lang-code="p_qb_displayLangCode_e"
                                    :popup-text="ass_strings.question_skipRiddle"
                                    :notification-num="p_skipsLeft_n"
                                    :approve-cb="() => {m_userEvents_skipLock(lockIndex_n)} ">

                                <img class="TQ_width_24px TQ_verticalAlignMiddle" :src="ass_img_skip_w" />
                                <div class="TQ_padding_4px TQ_inline"></div>
                                <div class="TQ_inline TQ_verticalAlignMiddle ">
                                    {{ass_strings.oneWord_skip[p_qb_displayLangCode_e]}}
                                </div>

                            </tq-btn-approve>
                        </tq-loader-button>

                     

                    </div>

                    <!-- finish lock icon-->
                    <div v-else-if="![enum_lockTypes.TRIVIA, enum_lockTypes.IMAGE, enum_lockTypes.VIDEO, enum_lockTypes.GPS].includes(lock_c.qbrl_type_e)" class="TQ_padding_8px">

                        <!-- points lock -->
                        <div v-if="p_qb_metadata_c.qbm_missions_supportMissionsPoints_b" class="TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius TQ_direction_ltr" >
                            <div class="TQ_text_bold TQ_inline TQ_verticalAlignTop"> +{{lock_c.qbrl_points_n}}</div>
                            <div class="TQ_padding_2px TQ_inline TQ_verticalAlignTop"></div>
                            <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_16px TQ_inline TQ_verticalAlignTop"/>
                        </div>

                        <!-- regular lock -->
                        <div v-else class="TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius">
                            <tq-image :pb_src_r="ass_img_unlock2_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                            <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px"></div>
                            <div class="TQ_text_bold TQ_inline TQ_verticalAlignMiddle">
                                {{ass_strings.twoWords_unlockLock[p_qb_displayLangCode_e]}}</div>
                        </div>

                        <!-- send to server loader -->
                        <tq-loader-container :p_showLoader_b="!p_riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n].wsr_serverReceivedData_b"></tq-loader-container>

                    </div>

                </div>

            </div>
        </div>

        <!-- 7) last section -->
        <div v-if="p_qb_riddle_c.qbr_metadata_c.qbrm_finishSection_b && co_finishCurrentRiddle_b">

            <hr>
            <div class="TQ_btn TQ_bg_gold_w TQ_margin_bottom_8px TQ_borderRadius TQ_text_24px"
                 @click="popup_lastSection_show_v.val = true">
                {{ass_strings.sentence_forMoreInfoClickHere[p_system_langCode_e]}}
            </div>

            <tq-popup :show="popup_lastSection_show_v"
                      margin="16px"
                      padding="8px"
                      max-width="500px"
                      :show-close-btn="true">

                <div v-html="p_qb_riddle_c.qbr_finishSection_blc_c[p_qb_displayLangCode_e].w_body_s"
                     class="TQ_margin_8px" >
                </div>

            </tq-popup>

        </div>

        <!-- 8) get_clue popup -->
        <tq-popup :show="popup_clue_show_v"
                  :show-close-btn="true"
                  v-if="popup_clue_show_v.val"
                  width="100%" margin="16px" padding="0px" maxWidth="350px" class="popup">

            <!-- gradual clue-->
            <div v-if="[enum_cluesMode_e.points_gradual, enum_cluesMode_e.counter_gradual].includes(p_qb_metadata_c.qbm_missions_cluesMode_e)">
                <div class="TQ_text_bold TQ_text_24px TQ_padding_8px TQ_bg_purple_dark">
                    {{p_qb_riddle_c.qbr_clues_ac[co_nextAvailableCluePointsIndex_n].qbrc_title_blc_s[p_qb_displayLangCode_e]}}
                </div>

                <div class="TQ_text_20px TQ_padding_8px">

                    <div v-if="p_qb_metadata_c.qbm_missions_cluesMode_e === enum_cluesMode_e.points_gradual">
                        {{ass_strings.sentenceGroup_usePointsHint1[p_system_langCode_e]}}:
                        <div class="TQ_text_bold TQ_textColor_red TQ_margin_2px TQ_text_20px">
                            {{p_qb_riddle_c.qbr_clues_ac[co_nextAvailableCluePointsIndex_n].qbrc_pointsWorth_n}}
                            {{ass_strings.oneWord_points[p_system_langCode_e]}}
                        </div>
                    </div>

                    <div v-else-if="p_qb_metadata_c.qbm_missions_cluesMode_e === enum_cluesMode_e.counter_gradual">
                        {{ass_strings.question_useHint[p_system_langCode_e]}}
                    </div>
                </div>
            </div>


            <!-- choose clue -->
            <div v-else-if="[enum_cluesMode_e.counter, enum_cluesMode_e.points].includes(p_qb_metadata_c.qbm_missions_cluesMode_e)">
                <div class="TQ_text_bold TQ_text_24px TQ_padding_8px TQ_bg_purple_dark TQ_borderRadius_top TQ_text_capitalize">
                    {{ass_strings.twoWords_chooseClue[p_system_langCode_e]}}
                </div>

                <div class="TQ_padding_8px">
                    <div v-for="clueIndex in co_getAvailableRiddleCluesIndex_a"
                         @click="popup_clue_selectedIndex_n = clueIndex"
                         class="TQ_grid_col_Auto1frAuto TQ_grid_gap_16px TQ_padding_8px TQ_border_bottom_gray">
                        <tq-checkbox :p_checked_b="popup_clue_selectedIndex_n === clueIndex" class="TQ_width_32px TQ_height_32px TQ_grid_verticalCenter"/>
                        <div class="TQ_textAlign_initial TQ_grid_verticalCenter">{{p_qb_riddle_c.qbr_clues_ac[clueIndex].qbrc_title_blc_s[p_qb_displayLangCode_e]}}</div>
                        <div v-if="[enum_cluesMode_e.points].includes(p_qb_metadata_c.qbm_missions_cluesMode_e)" class="TQ_grid_verticalCenter">
                            <div class="TQ_borderRadius TQ_padding_4px TQ_text_14px TQ_textColor_white " :class="popup_clue_selectedIndex_n === clueIndex ? 'TQ_bg_red' : 'TQ_bg_gray1'">
                                <div class="TQ_text_bold TQ_inline TQ_verticalAlignMiddle TQ_direction_ltr "> -{{p_qb_riddle_c.qbr_clues_ac[clueIndex].qbrc_pointsWorth_n}}</div>
                                <div class="TQ_padding_2px TQ_inline TQ_verticalAlignMiddle"></div>
                                <div class="TQ_inline">
                                    <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_12px TQ_inline TQ_verticalAlignMiddle"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- buttons -->
            <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_border_top">
                <div class="TQ_box_shadow2 TQ_clickable TQ_bg_red TQ_borderRadius TQ_padding_8px TQ_width_72px" @click="popup_clue_show_v.val = false">
                    {{ass_strings.oneWord_cancel[p_system_langCode_e]}}
                </div>
                <div></div>
                <div class="TQ_box_shadow2 TQ_clickable TQ_bg_green TQ_borderRadius TQ_padding_8px TQ_width_72px" @click="m_userEvents_clickApproveGetClue_f()">
                    {{ass_strings.oneWord_approve[p_system_langCode_e]}}
                </div>
            </div>

        </tq-popup>

    </div>
</template>

<script>
import {notification_notify} from "../../scripts/S_Notification";
    import {
        enum_cluesMode_e,
        enum_lockState,
        enum_mapTypes,
        enum_screenSizesOptions_n,
        enum_missions_LocksType_s,
        enum_subCollection_teamStatus,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from "../basic/TqCard";

    import NotificationContainer from "../basic/TqNotificationContainer";
    import Si_skip from "../a_smartIcons/si_skip";
    import Si_unlock from "../a_smartIcons/si_unlock";
    import Si_idea from "../a_smartIcons/si_clue";
    import Si_arrowRight from "../a_smartIcons/si_arrowsRight";
    import {helper_arrayToObj_an, helper_finishLock_fb, helper_finishRiddle_fb} from "../../scripts/S_Helper";
    import Si_arrowLeft from "../a_smartIcons/si_arrowsLeft";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqPopup from "../basic/TqPopup";
    import InputFastDelete from "../basic2/TqInputFastDelete";
    import DisplayFile from "../mediaComponenets/TqDisplayFile";
    import TqDropdown from "../basic/TqDropdown";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
import {
    ass_gif_gpsCalibrate,
    ass_gif_gpsSearchingLocation,
    ass_img_camera_b,
    ass_img_checked,
    ass_img_closeRed,
    ass_img_gps_w,
    ass_img_idea_w,
    ass_img_image, ass_img_location,
    ass_img_lock_w, ass_img_oneStar_w,
    ass_img_QrCode_b,
    ass_img_skip_w, ass_img_svg_fullscreen_b,
    ass_img_unlock2_w, ass_img_xLetter_r
} from "../../assets/scripts/Ass_Files"
    import {file_playAudio_f} from "../../scripts/S_Files";
    import {navigator_vibrate_f} from "../../scripts/S_Navigator";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
import {
    date_newDate_fd,
    date_doEveryClockTick_addCb_f, date_doEveryClockTick_removeCb_f, date_getTimePastInSeconds_fn, date_setTimeout
} from "../../scripts/S_Date";
import {
    format_date_YYYY_MM_DD_hh_mm_fs,
    format_duration_hhmmss,
    format_lockType_fs
} from "../../../functions/src/shareCode/Share_S_Format";
    import {
        FB_File, FB_QuestBody_Metadata,
        FB_QuestBody_Riddle,
        FB_QuestEvent, FB_RiddleStatus, FB_RiddleStatus_unlockData, FB_RS_LockActions
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import {validator_null_fb, validator_class_fb, validator_objClass_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_langCodes,
        enum_lockQuestionsTypes,
        enum_lockTypes,
        enum_vibrationPatterns
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import TqLeafletDisplay from "../maps/TqLeafletDisplay";
    import TqGoogleMap from "../maps/TqGoogleMap";
    import {
        webAppManager_captureImage_f,
        webAppManager_captureVideo_f, webAppManager_geoLocationListener_set_f, webAppManager_geoLocationListener_stop_f,
    } from "../../scripts/S_WebAppMediator";
    import TqLoaderButton from "../basic2/TqLoaderButton";
    import {obj_size_fn, obj_forEach_f} from "../../../functions/src/shareCode/Share_S_Obj";
    import TqImage from "../basic/TqImage";
    import TqTrivia from "../basic2/TqTrivia";
    import TqCheckbox from "../basic/TqCheckbox";
    import TqImgFillBlur from "../basic2/TqImgFillBlur";
    import TqBeacon from "../basic2/TqBeacon";
    import {
        serverOngoing_teamStatus_riddleStatus_startMissionTime_f,
        serverOngoing_teamStatusSub_riddleStatus_actions_update_f,
    } from "../../scripts/Server/S_ServerOngoing";
    import {store_getStateValue_vo, store_var} from "../../store";
    import {FB_MapPlayerLocation} from "@/classes/client_classes";
import {map_distanceTwoPointsMeters_fn} from "@/scripts/API/S_Map";
import {serverAuth_getOtherUserData_f} from "@/scripts/Server/S_ServerAuth";
import TqLoaderContainer from '../basic/TqLoaderContainer';

    export default {
        name: "TqRiddleData",
        components: {
            TqBeacon,
            TqImgFillBlur,
            TqCheckbox,
            TqTrivia,
            TqImage,
            TqLoaderButton,
            TqGoogleMap,
            TqLeafletDisplay,
            TqOnTopContainer,
            TqDropdown,
            TqBtnApprove,
            DisplayFile,
            InputFastDelete,
            TqPopup,
            Si_arrowLeft,
            Si_arrowRight,
            Si_idea,
            Si_unlock,
            Si_skip,
            NotificationContainer,
            TqCard,
            TqLoaderContainer
        },
        props: {

            // ========= basic =============
            p_name_s                : {
                type: String,
                require: true,
            },
            p_system_langCode_e     : {
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_qb_displayLangCode_e  : {
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_teamStatus_subCollection_e  : {
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_subCollection_teamStatus, val)
                }
            },
            p_windowSize_e          : {
                type: Number,
                default: enum_screenSizesOptions_n.mobile,
                validator(windowSize_n){
                    return validator_enum_fb(enum_screenSizesOptions_n, windowSize_n)
                }
            },
            p_userId_uid            : {
                type:String,
                require: true
            },

            // ========= riddle data =============
            p_riddleStatus_c:{
                type: FB_RiddleStatus,
            },
            p_qb_riddle_c:{
                type: FB_QuestBody_Riddle,
                require: true,
            },

            // ========= players location =============
            p_playersLocation_byUserId_c :{
                type: Object,
                validator(obj){
                    return validator_objClass_fb(obj, FB_MapPlayerLocation)
                },
                default(){
                    return {}
                }
            },
            p_currentUserLocation_c : {
                type:FB_MapPlayerLocation,
                validator(val){
                    return validator_null_fb(val) || validator_class_fb(val, FB_MapPlayerLocation)
                }
            },

            // ========= skips and clues =============
            p_cluesLeft_n :{
                type: Number,
                require: true
            },
            p_skipsLeft_n :{
                type: Number,
                require: true
            },

            // ========= others =============
            p_displayRiddleImage_b:{
                type: Boolean,
                default: false
            },
            p_cardsMode_b:{
                type: Boolean,
                default: false
            },
            p_qb_metadata_c:{
                type: FB_QuestBody_Metadata,
                require: true
            },

            // ========= functions =============
            p_clickGetClue_f:{
                type: Function,
                require: true
            },
            p_clickSkipRiddle_f:{
                type: Function,
                require: true
            },
            pe_rs_unlockData_update_f:{
                type: Function,
                default(){
                    return () => {}
                }
            },
            pe_startWatchPosition_f:{
                type: Function,
            },
            pe_stopWatchPosition_f:{
                type: Function,
            },
            pe_clickImage_f:{
                type: Function,
            },


        },
        data(){
            return {

                userAns_byUserAnsId     : {},
                refreshMapCounter_n     : 0,

                p_showInOrderLocks      : true,

                loaderClueBtn_b             : false,
                loaderSkipBtn_b             : false,
                loaderSubmitBtnIndex_n      : -1,
                clockFormatTime_s           : '--:--:--',

                popup_clue_show_v           : {val: false},
                popup_clue_selectedIndex_n  : 0,
                popup_lastSection_show_v    : {val: true},

                fileLock_clickedLockIndex_n : null,
                fileLock_clickedFacebookBtn_b : false,
                showGpsNotAccurateMsg_b : false,
                
                server_userData_byUserId_c : {},

                // store
                store_questEvent_c       : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid  : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid),

                // import assents
                format_lockType_fs      : format_lockType_fs,
                format_date_YYYY_MM_DD_hh_mm_fs      : format_date_YYYY_MM_DD_hh_mm_fs,

                enum_lockTypes          : enum_lockTypes,
                enum_lockQuestionsTypes : enum_lockQuestionsTypes,
                enum_mapTypes           : enum_mapTypes,
                enum_lockStatus         : enum_lockState,
                enum_cluesMode_e        : enum_cluesMode_e,
                ass_strings             : ass_strings,
                ass_img_image           : ass_img_image,
                ass_img_camera          : ass_img_camera_b,
                ass_img_lockQrCode      : ass_img_QrCode_b,
                ass_img_skip_w          : ass_img_skip_w,
                ass_img_lock_white      : ass_img_lock_w,
                ass_img_unlock2_w       : ass_img_unlock2_w,
                ass_img_idea_w          : ass_img_idea_w,
                ass_img_oneStar_w       : ass_img_oneStar_w,
                ass_img_svg_fullscreen_b: ass_img_svg_fullscreen_b,
                ass_img_gps_w           : ass_img_gps_w,
                ass_img_location           : ass_img_location,
                ass_gif_gpsSearchingLocation      : ass_gif_gpsSearchingLocation,
                ass_gif_gpsCalibrate      : ass_gif_gpsCalibrate,
                ass_img_closeRed : ass_img_closeRed,
                ass_img_checked : ass_img_checked
                

            }
        },
        computed:{

            co_supportMissionClock_b(){
                return this.p_qb_metadata_c.qbm_missions_locksType_e === enum_missions_LocksType_s.start_time && this.p_teamStatus_subCollection_e !== null
            },
            co_missionClock_ready_b(){
                return this.co_supportMissionClock_b && (this.p_riddleStatus_c == null || this.p_riddleStatus_c.rs_startMissionTime_t === null)
            },
            co_missionClock_running_b(){
                return this.co_supportMissionClock_b && this.p_riddleStatus_c && this.p_riddleStatus_c.rs_startMissionTime_t !== null && !this.co_finishCurrentRiddle_b
            },
            co_missionClock_finish_b(){
                return this.co_supportMissionClock_b && this.p_riddleStatus_c && this.p_riddleStatus_c.rs_startMissionTime_t !== null && this.co_finishCurrentRiddle_b
            },
            co_totalFinishMissionTime_s(){
                if(this.co_missionClock_finish_b){
                    return format_duration_hhmmss(this.p_riddleStatus_c.rs_m_missionTotalTime_t())
                }

            },
            co_mainImageHeight_s(){
                switch(this.p_windowSize_e){
                    case enum_screenSizesOptions_n.laptop:
                    case enum_screenSizesOptions_n.tablet_big:
                    case enum_screenSizesOptions_n.tablet_small:
                        return '450px'
                    case enum_screenSizesOptions_n.mobile:
                        return '250px'

                }
            },
            co_finishCurrentRiddle_b(){
                return helper_finishRiddle_fb(this.p_qb_riddle_c, this.p_riddleStatus_c)
            },
            co_nextAvailableCluePointsIndex_n(){

                if(this.p_riddleStatus_c == null){
                    return 0
                }

                return obj_size_fn(this.p_riddleStatus_c.rs_clues_byClueId_c)
            },
            co_getAvailableRiddleCluesIndex_a(){
                let ans = [];
                for(let i = 0; i < this.p_qb_riddle_c.qbr_clues_ac.length; i++){
                    if(!this.m_showClue_fb(i))
                        ans.push(i)
                }
                return ans
            },
            co_qbr_locks_ac(){

                if(this.p_qb_riddle_c.qbr_metadata_c.qbrm_displayLocksInOrder_b){
                    const ans = [this.p_qb_riddle_c.qbr_locks_ac[0]]

                    for(let i=1; i<this.p_qb_riddle_c.qbr_locks_ac.length; i++){
                        if(this.m_dom_finishLock_fb(i-1)){
                            ans.push(this.p_qb_riddle_c.qbr_locks_ac[i])
                        }else{
                            return ans
                        }
                    }
                    return ans

                }else{
                    return this.p_qb_riddle_c.qbr_locks_ac
                }
            },

            // dom
            co_dom_showGetClue_b(){

                // todo: check this.p_qb_riddle_c.qbr_clues_ac.length > 0
                return this.p_qb_riddle_c
                    && this.p_qb_riddle_c.qbr_clues_ac != null
                    && this.co_getAvailableRiddleCluesIndex_a.length > 0
            },
            co_dom_titleStyle_s(){
                return {
                    background  : this.p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s,
                    fontFamily  : this.p_qb_riddle_c.qbr_theme_c.qbrt_font_s,
                    color       : this.p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s,
                    fontSize    : this.p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s
                }
            },
            co_dom_subTitleStyle_s(){
                return {
                    background  : this.p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s,
                    fontFamily  : this.p_qb_riddle_c.qbr_theme_c.qbrt_font_s,
                    color       : this.p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s,
                    fontSize    : 'calc(' + this.p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s + ' - 8px)'
                }
            },


        },
        methods: {

            // local
            m_showClue_fb(clueIndex){

                return this.p_riddleStatus_c != null &&
                    this.p_riddleStatus_c.rs_clues_byClueId_c != null &&
                    this.p_riddleStatus_c.rs_clues_byClueId_c[clueIndex] != null
            },
            m_getRiddleStatus_unlock_fc(lockId_n){

                if (this.p_riddleStatus_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n] == null)
                    return {};

                return this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n]
            },
            m_localUserAns_get_f(lockId_n, questionIndex, ansIndex){

                return this.userAns_byUserAnsId[this.m_helper_userAnsId_s(lockId_n, questionIndex, ansIndex)]
            },
            m_localUserAns_set_f(lockIndex, questionIndex, ansIndex, val){
                this.$set(this.userAns_byUserAnsId,  this.m_helper_userAnsId_s(lockIndex, questionIndex, ansIndex), val)
            },

            m_clickHtmlBody_f(event){
                if(event && event.target && event.target.getAttribute('tqClickable') && this.pe_clickImage_f){
                    this.pe_clickImage_f(event.path[0].parentElement.childNodes[1].src)
                }
            },
            m_formatHtml_f(html_s){
                return html_s

               // return html_s.replace(re_startAndEndWith_s('<img', '>'), (match, offset, string) => {
               //
               //     return `<div style="display:inline-table; direction: ltr">
               //                  ${match}
               //                  <img tqClickable="true" style="vertical-align: top; margin-top: 4px; margin-left: -28px;  cursor: pointer; background:white; border-radius: 5px; padding: 2px;  width:20px;" src="${ass_img_svg_fullscreen_b}"/>
               //              </div>`
               //  })
            },

            // dom
            m_dom_getLockDisplayImgFile_c(lockId_n, ansIndex_n){

                let localImage_b = this.m_localUserAns_get_f(lockId_n, null, ansIndex_n) != null
                let serverImage_b = this.p_riddleStatus_c != null
                    && this.p_riddleStatus_c.rs_unlock_byLockId_c != null
                    && this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n] != null
                    && this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n].rsud_imgFile_c != null

                let serverFile_fc = () => {return new FB_File(this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n].rsud_imgFile_c)}
                let localFile_fc = () => {return this.m_localUserAns_get_f(lockId_n, null, ansIndex_n)}


                // get from server
                if(serverImage_b && localImage_b){
                    return localFile_fc()
                } else if(serverImage_b){
                    return serverFile_fc()
                } else if(localImage_b){
                    return localFile_fc()
                }else {
                    return null
                }

            },
            m_dom_finishLock_fb(lockIndex_n){
                return helper_finishLock_fb(this.p_riddleStatus_c, lockIndex_n, this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e)
            },
            m_dom_skipLock_fb(lockIndex_n){

                if(this.p_riddleStatus_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n] == null){
                    return false
                }

                return this.p_riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n].rsud_skip_b
            },
            m_dom_setClockFormatTime_f(){
                if(this.co_missionClock_running_b){
                    let seconds_n = date_getTimePastInSeconds_fn(this.p_riddleStatus_c.rs_startMissionTime_t)
                    this.clockFormatTime_s = format_duration_hhmmss(seconds_n * 1000)
                }else{
                    this.clockFormatTime_s = '--:--:--'
                }
            },

            // user events
            m_userEvents_skipLock(lockIndex_n){
                let unlocksData_byLockId = {
                    [lockIndex_n] : new FB_RiddleStatus_unlockData({
                        rsud_userId_uid     : this.p_userId_uid,
                        rsud_timestemp_t    : date_newDate_fd().getTime(),
                        rsud_lockState_e    : enum_lockState.approved,
                        rsud_skip_b         : true,
                        rsud_lockType_e     : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e,
                        rsud_receivedPoints_n : 0,
                    })
                }

                this.loaderSkipBtn_b = true
                this.p_clickSkipRiddle_f(unlocksData_byLockId, () => {
                    this.loaderSkipBtn_b = false
                })
            },
            m_userEvents_submitQuizAns_f(lockIndex_n){

                if(!this.pe_rs_unlockData_update_f){return}

                let userAns_a_by_s = []
                for(let questionIndex_n in this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_questions_ac){
                    let qbrl_questions_c = this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_questions_ac[questionIndex_n];

                    let userAns_as = []

                    // 2) OPTIONS/WORDS
                    if([enum_lockTypes.WORDS, enum_lockTypes.OPTIONS].includes(qbrl_questions_c.qbrlq_type_e)){
                        let leftAnsArr_as =  qbrl_questions_c.qbrlq_ans_blc_ac[this.p_qb_displayLangCode_e].slice()
                        leftAnsArr_as = leftAnsArr_as.map(encValue_c => encValue_c.enc_value_s)

                        // case insensitive
                        if(!qbrl_questions_c.qbrlq_caseSensitive_b){
                            leftAnsArr_as = leftAnsArr_as.map((value_s) => {return value_s.toLowerCase()})
                        }

                        for(let ansIndex=0; ansIndex< qbrl_questions_c.qbrlq_ansNum_blc_n[this.p_qb_displayLangCode_e]; ansIndex++){

                            let userAns_s = this.m_localUserAns_get_f(lockIndex_n,questionIndex_n, ansIndex)
                            userAns_as.push(userAns_s)

                            // case insensitive
                            if(userAns_s!= null && !qbrl_questions_c.qbrlq_caseSensitive_b){userAns_s = userAns_s.toLowerCase()}

                            let newAnsIndex_n = leftAnsArr_as.indexOf(userAns_s);
                            if(newAnsIndex_n > -1){
                                leftAnsArr_as.splice(newAnsIndex_n, 1)
                            }else{
                                notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_wrongAnswer, null, 1000)
                                file_playAudio_f(this.p_qb_metadata_c.qbm_audio_missionErrorUrl_s)
                                navigator_vibrate_f(enum_vibrationPatterns.error)
                                return
                            }
                        }
                    // INCLUDES_WORDS
                    }
                    else if([enum_lockTypes.INCLUDE_WORD].includes(qbrl_questions_c.qbrlq_type_e)){

                        let userAns_s =  this.m_localUserAns_get_f(lockIndex_n, questionIndex_n, 0)

                        // case insensitive
                        if(userAns_s != null && !qbrl_questions_c.qbrlq_caseSensitive_b){userAns_s = userAns_s.toLowerCase()}
                        let ansNum = 0


                        qbrl_questions_c.qbrlq_ans_blc_ac[this.p_qb_displayLangCode_e].forEach(encryptedAns_s => {

                            let ans_s = encryptedAns_s.enc_value_s
                            // case insensitive
                            if(!qbrl_questions_c.qbrlq_caseSensitive_b){ans_s = ans_s.toLowerCase()}

                            if(userAns_s != null && userAns_s.includes(ans_s)){
                                ansNum++
                            }
                        });

                        if(ansNum < qbrl_questions_c.qbrlq_ansNum_blc_n[this.p_qb_displayLangCode_e]){
                            notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_wrongAnswer, null, 1000)
                            file_playAudio_f(this.p_qb_metadata_c.qbm_audio_missionErrorUrl_s)
                            navigator_vibrate_f(enum_vibrationPatterns.error)
                            return
                        }else{
                            userAns_as = [userAns_s]
                        }
                    }

                    userAns_a_by_s.push(helper_arrayToObj_an(userAns_as))
                }

                this.loaderSubmitBtnIndex_n = lockIndex_n

                this.pe_rs_unlockData_update_f(
                    lockIndex_n,
                    new FB_RiddleStatus_unlockData({
                        rsud_userId_uid                         : this.p_userId_uid,
                        rsud_lockState_e                        : enum_lockState.approved,
                        rsud_timestemp_t                        : (date_newDate_fd()).getTime(),
                        rsud_quizUserAns_byQuestionIndex_as     : helper_arrayToObj_an(userAns_a_by_s),
                        rsud_lockType_e                         : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e,
                        rsud_receivedPoints_n                   : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_points_n,
                    }),
                    () => {
                        this.loaderSubmitBtnIndex_n = -1
                    }
                )


            },
            m_userEvents_clickLockFile_f(lockIndex_n){

                this.fileLock_clickedFacebookBtn_b = false
                this.fileLock_clickedLockIndex_n = lockIndex_n

                switch(this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e){

                    case enum_lockTypes.IMAGE:
                        webAppManager_captureImage_f(this.m_userEvents_chooseFile_f)
                        break;

                    case enum_lockTypes.VIDEO:
                        webAppManager_captureVideo_f(this.m_userEvents_chooseFile_f)
                        break;
                }
            },
            m_userEvents_chooseFile_f(blob){

                if(blob == null)
                    return;


                let lockIndex_n = this.fileLock_clickedLockIndex_n
                let ansIndex_n = 0

                if(blob.size > gv_numbers.maxFileSizeInByte){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_fileIsTooBig)
                    return
                }

                const rs_unlockData_c = new FB_RiddleStatus_unlockData({
                        rsud_userId_uid : this.p_userId_uid,
                        rsud_timestemp_t : (date_newDate_fd()).getTime(),
                        rsud_lockState_e : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_autoApprove_b ? enum_lockState.approved : enum_lockState.waitingToApprove,
                        rsud_imgFile_c : new FB_File({
                            fi_fileName_s : `lockImage_${this.p_name_s}_${lockIndex_n}_${ansIndex_n}`,
                            fi_url_s : URL.createObjectURL(blob),  // blob

                            fi_type_e : blob.type,
                            fi_index_n : 0,
                            fi_sizeBytes_n : blob.size
                        }),
                        rsud_lockType_e : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e,
                        rsud_receivedPoints_n : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_points_n,
                    })

                this.m_localUserAns_set_f(lockIndex_n, null, ansIndex_n, rs_unlockData_c.rsud_imgFile_c)

                this.pe_rs_unlockData_update_f(lockIndex_n, rs_unlockData_c, () => {})
            },
            m_userEvents_clickGetClue_f(){
                this.popup_clue_show_v.val = true
                this.popup_clue_selectedIndex_n = this.co_getAvailableRiddleCluesIndex_a[0]
            },
            m_userEvents_clickApproveGetClue_f(){

                let clueIndex_n;
                if([enum_cluesMode_e.points_gradual, enum_cluesMode_e.counter_gradual].includes(this.p_qb_metadata_c.qbm_missions_cluesMode_e)){
                    clueIndex_n = this.co_nextAvailableCluePointsIndex_n

                }else{
                    if(this.p_cluesLeft_n  <= 0 ) {
                        notification_notify(ass_strings.oneWord_error, ass_strings.threeWords_noHintsLeft)
                        return;
                    }
                    clueIndex_n = this.popup_clue_selectedIndex_n
                }

                this.popup_clue_show_v.val = false
                this.loaderClueBtn_b = true
                this.p_clickGetClue_f(clueIndex_n, () => {
                    this.loaderClueBtn_b = false
                })
            },
            m_userEvents_startTrivia_f(lockIndex_n, cb_f){

                this.pe_rs_unlockData_update_f(
                    lockIndex_n,
                    new FB_RiddleStatus_unlockData({
                        rsud_userId_uid         : this.p_userId_uid,
                        rsud_timestemp_t        : (date_newDate_fd()).getTime(),
                        rsud_lockType_e         : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e,
                    }),
                    cb_f)
            },
            m_userEvents_finishTrivia_f(lockIndex_n, startTrivia_t, userAns_aas, cb_f){
                this.pe_rs_unlockData_update_f(
                    lockIndex_n,
                    new FB_RiddleStatus_unlockData({
                            rsud_userId_uid         : this.p_userId_uid,
                            rsud_timestemp_t        : startTrivia_t,
                            rsud_quizUserAns_byQuestionIndex_as    : helper_arrayToObj_an(userAns_aas),
                            rsud_lockType_e : this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e,
                        },
                        cb_f),
                )
            },
            m_userEvents_startMissionClock_f(){
                serverOngoing_teamStatus_riddleStatus_startMissionTime_f({
                    teamStatus_subCollection_e: this.p_teamStatus_subCollection_e,
                    questEvent_c:this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid.val ,
                    riddleId_n: this.p_qb_riddle_c.qbr_riddleId_n,
                    cb_f: (data_o)=>{
                        console.log("startClock",data_o)
                    }
                })
            },

            m_getOtherUserData_c(userId_uid){
                if(this.server_userData_byUserId_c[userId_uid] !== undefined){
                    return this.server_userData_byUserId_c[userId_uid]
                }

                this.$set(this.server_userData_byUserId_c, userId_uid, null)

                serverAuth_getOtherUserData_f(userId_uid, (userData_c) => {
                    this.server_userData_byUserId_c[userId_uid] = userData_c
                })

                return this.server_userData_byUserId_c[userId_uid]
            },
            m_calculateDistance_n(qbr_lockData_c, rs_action_c){

                return map_distanceTwoPointsMeters_fn({
                    lat1: qbr_lockData_c.qbrl_gpsLocation_c.mp_lat_n,
                    lon1: qbr_lockData_c.qbrl_gpsLocation_c.mp_lng_n,
                    lat2: rs_action_c.rsla_geoLocation_c.ugl_latitude_n,
                    lon2: rs_action_c.rsla_geoLocation_c.ugl_longitude_n,
                })
            },
            // lock
            m_lockGps_checkMyCurrentLocation_f(qbr_lock_c, lockIndex_n){

                let waitOneSecond_b = false
                date_setTimeout(()=>{
                    waitOneSecond_b = true
                }, 1000, 'm_lockGps_checkMyCurrentLocation_f')

                webAppManager_geoLocationListener_set_f(this.$options.name,  (userGeoLocation_c) => {

                    this.loaderSubmitBtnIndex_n = lockIndex_n

                     // 0) wait one second
                     if(!waitOneSecond_b){
                         return
                    }

                    // 1) location is not accurate
                    if(!userGeoLocation_c.ugl_f_accurateGeoLocation_b()){
                        this.showGpsNotAccurateMsg_b = true
                        return
                    }
                    this.showGpsNotAccurateMsg_b = false

                    // 2) stop geoListener
                    webAppManager_geoLocationListener_stop_f(this.$options.name)

                    // 3) create actions
                    const rs_action_c = new FB_RS_LockActions({
                        rsla_lockIndex_n : lockIndex_n,
                        rsla_userId_uid : this.p_userId_uid,
                        rsla_geoLocation_c : userGeoLocation_c,
                        rsla_rightAns_b : qbr_lock_c.gbrl_f_locationInRadius_b(userGeoLocation_c),
                    })

                    // 4) update db
                    serverOngoing_teamStatusSub_riddleStatus_actions_update_f({
                        teamStatus_subCollection_e  : this.p_teamStatus_subCollection_e,
                        questEvent_c                : this.store_questEvent_c,
                        teamId_uid                  : this.store_currentTeamId_uid.val,
                        riddleData_c                : this.p_qb_riddle_c,
                        riddleStatus_c              : this.p_riddleStatus_c,
                        lockIndex_n                 : lockIndex_n,
                        rs_action_c                 : rs_action_c,

                        cb_f : () => {

                            if(!rs_action_c.rsla_rightAns_b){
                                notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_wrongAnswer, null, 1000)
                                file_playAudio_f(this.p_qb_metadata_c.qbm_audio_missionErrorUrl_s)
                                navigator_vibrate_f(enum_vibrationPatterns.error)
                            }

                            this.loaderSubmitBtnIndex_n = -1
                        }
                    })

                })
            },
            m_lockGps_numOfTries_n(lockIndex_n){
                if(this.p_riddleStatus_c == null)
                    return 0

                return obj_size_fn(this.p_riddleStatus_c.rs_lockActions_byLockIndex_byTime_c[lockIndex_n])
            },

            // helpers
            m_helper_userAnsId_s(lockIndex, questionIndex, ansIndex){
                return `${lockIndex}_${questionIndex}_${ansIndex}`
            },

        },
        activated(){
            this.popup_lastSection_show_v.val = true
            // this.refreshMapCounter_n++
            this.m_dom_setClockFormatTime_f()
        },
        mounted(){
            if(this.co_supportMissionClock_b){
                date_doEveryClockTick_addCb_f(this.$options.name, () => {
                    this.m_dom_setClockFormatTime_f()
                })
            }
        },
        destroyed(){
            date_doEveryClockTick_removeCb_f(this.$options.name)
        }
    }
</script>

<style scoped lang="scss">

    .lc_title{
        padding: 8px 0px;
    }

    .lc_pointsLabel{
        margin-bottom: 32px;
        border-top: 1px solid white;
        border-left: 1px solid white;
        border-bottom: 1px solid white;
        border-radius: 4px 0 0 8px;
    }

    .riddleSubTitle{
        background: gray;
        color: white;
        border-top:1px solid black;
        border-bottom:1px solid black;
        padding: 4px;
    }


    .buttons{
        /*background: green;*/
        display: grid;
        grid-column-gap: 16px;

        &.twoGrid{
            grid-template-columns: auto auto ;
        }

        &.threeGrid{
            grid-template-columns: auto auto auto;
        }
    }

</style>